/**
 * Conversation-history annotations sent to the AI — must match the user's UI language
 * so the model is not primed with English-only system lines.
 */

export function isSpanishUiLocale(locale) {
  return String(locale || 'en').toLowerCase().startsWith('es');
}

export function historyJobLoggedSuffix(locale, actionResult) {
  if (!actionResult) return '';
  const total = actionResult.total;
  const jobId = actionResult.job_id;
  if (isSpanishUiLocale(locale)) {
    return `\n[Sistema: Trabajo registrado — total $${total}, job_id: ${jobId}]`;
  }
  return `\n[System: Job was logged — total $${total}, job_id: ${jobId}]`;
}

export function historyEditManuallySuffix(locale) {
  if (isSpanishUiLocale(locale)) {
    return '\n[Sistema: El usuario eligió editar el trabajo manualmente en el formulario]';
  }
  return '\n[System: User chose to edit the job manually in the form]';
}
